import { Routes } from 'shared'
const pathRegex = /^\/[^/].*$/

export const isPath = (string: string) => string.match(pathRegex)

export class URLHelper {
  static get signUpPath() {
    return Routes.signUpPath({ return_to: window.location.pathname })
  }
}
